import React from 'react'
import PropTypes from 'prop-types'
import AgentAuthenticationModal from '../../containers/Admin/Surveys/ZendeskIntegrationSettings/AgentAuthenticationModal'

const ActivatedAuthentication = ({ surveyId }) => (
  <div>
    <div className="ui segment">
      <div className="ui stackable grid">
        <div className="ten wide column middle aligned">
          <h4>
            <i className="ui icon info circle" /> Simplesat isn't authenticated with Zendesk yet
          </h4>
        </div>
        <div className="six wide column right aligned">
          <AgentAuthenticationModal surveyId={surveyId} />
        </div>
      </div>
    </div>
  </div>
)

ActivatedAuthentication.propTypes = {
  surveyId: PropTypes.string.isRequired,
}

export default ActivatedAuthentication



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Zendesk/ActivateAuthentication.js